export const REPORT_ACTIONS = {
  SET_LOADING: "SET_LOADING",
  TOGGLE_REPORT_POPUP: "TOGGLE_REPORT_POPUP",
  SET_VEHICLES_IN_POI: "SET_VEHICLES_IN_POI",
  SET_DOC_EXPIRY_LIST: "SET_DOC_EXPIRY_LIST",
};
